import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import DeleteSport from "../../../../Controllers/Admin/Sports/DeleteSport";
import GetAllSports from "../../../../Controllers/Admin/Sports/GetAllSports";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function SportsListingViewModel() {
  const [SportID, setSportID] = useState("");
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [Refresh, setRefresh] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [AuthUser, setAuthUser] = useState();
  const [SportsArray, setSportsArray] = useState([]);

  const HandleRefresh = () => {
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const SchoolsData = await GetAllSports(AuthUser?.uid, SchoolID);
      setSportsArray(SchoolsData);
    }
    fetchData();
    setIsLoading(false);
  }, [AuthUser?.uid, SchoolID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setSportID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteSport(SportID);
      ToastSuccessMessages("sports/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    SportsArray,
    IsLoading,
  };
}
